import React, { useRef } from 'react';
import classNames from 'classnames';
import useIntersectionObserver from '../../features/useIntersectionObserver';
import useResizeObserver from '../../features/useResizeObserver';
import { ScrollObserverCore } from '../../features/ScrollObserver';
/**
 * Bronson FloatingBar component.
 *
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-floating-bar.html
 *
 * @constructor
 */
export function FloatingBar({ children, className, target, testId, ...otherProps }) {
    const floatingBarRef = useRef(null);
    /**
     * Track resizing on the FloatingBar ref and get current offset height.
     */
    useResizeObserver({
        ref: floatingBarRef,
        onResizeHandler: () => {
            const elementOffsetHeight = floatingBarRef?.current?.offsetHeight ?? '';
            document.documentElement.style.setProperty('--bron-sticky-offset', `${elementOffsetHeight}px`);
        },
    });
    /**
     * Track the target container.
     */
    useIntersectionObserver({
        ref: floatingBarRef,
        target,
        onIntersectionHandler: ScrollObserverCore.observeEntries,
        opts: {
            intersectionObserverOpts: { rootMargin: '0px', threshold: [0, 1] },
            classes: ScrollObserverCore.classes,
        },
    });
    const aClass = classNames('c-floating-bar', className).trim();
    /**
     * Handle scroll to the desired element.
     * @param {HTMLElement} scrollToRef- The element to scroll to.
     */
    const scrollTo = (scrollToRef) => scrollToRef?.current && window.scrollTo(0, scrollToRef.current.offsetTop);
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { ref: floatingBarRef, "data-testid": testId, className: aClass, "data-scroll": true, onClick: () => scrollTo(target), ...otherProps },
            React.createElement("div", { className: "c-floating-bar__inner" }, children))));
}
